export const ADMIN_WELCOME_EMAIL_FORM = 'adminWelcomeEmailForm'
